/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export const WithDropdown = React.forwardRef(({ children, dropdownContent, open, minWidth, minHeight, orientation, className, style }, ref) => (
  <div
    className={`slds-dropdown-trigger slds-dropdown-trigger_click${open ? ' slds-is-open' : ''} ${className ? className : ''}`}
    style={style}>
    {children}  {/* 'children element to contain the trigger(s) */}
    <div
      ref={ref}
      className={`slds-dropdown slds-dropdown_${orientation} slds-text-align_left`}
      style={{ minWidth: minWidth, minHeight: minHeight }}>
      {dropdownContent}
    </div>
  </div>
))

WithDropdown.propTypes = {
  children: PropTypes.any.isRequired,
  dropdownContent: PropTypes.any.isRequired,
  open: PropTypes.bool,
  minWidth: PropTypes.number,
  minHeight: PropTypes.number,
  orientation: PropTypes.oneOf([ 'left', 'right' ]),
  className: PropTypes.string,
  style: PropTypes.object
}

WithDropdown.defaultProps = {
  orientation: 'left'
}



// WEBPACK FOOTER //
// ./src/components/with-dropdown/index.js